import { API } from './api';

export const GetNews = (params: any) => API.get('/cabinet/news/', params);
